import {
  SAVE_SYSTEM_SETTINGS,
  SAVE_SYSTEM_SETTINGS_SUCCESS,
  SAVE_SYSTEM_SETTINGS_FAILURE,
  SAVE_SYSTEM_SETTINGS_RESET,
  GET_SYSTEM_SETTINGS,
  GET_SYSTEM_SETTINGS_SUCCESS,
  GET_SYSTEM_SETTINGS_FAILURE,
  GET_SYSTEM_SETTINGS_RESET,
} from "../ActionTypes"

export const saveSystemSettings = payload => ({
  type: SAVE_SYSTEM_SETTINGS,
  payload
})

export const saveSystemSettingsSuccess = payload => ({
  type: SAVE_SYSTEM_SETTINGS_SUCCESS,
  payload
})

export const saveSystemSettingsFailure = payload => ({
  type: SAVE_SYSTEM_SETTINGS_FAILURE,
  payload
})

export const saveSystemSettingsReset = payload => ({
  type: SAVE_SYSTEM_SETTINGS_RESET,
  payload
})


export const getSystemSettings = payload => ({
  type: GET_SYSTEM_SETTINGS,
  payload
})

export const getSystemSettingsSuccess = payload => ({
  type: GET_SYSTEM_SETTINGS_SUCCESS,
  payload
})

export const getSystemSettingsFailure = payload => ({
  type: GET_SYSTEM_SETTINGS_FAILURE,
  payload
})

export const getSystemSettingsReset = payload => ({
  type: GET_SYSTEM_SETTINGS_RESET,
  payload
})




